import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { LangProvider } from "@/lib/lang";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Pricing from "@/pages/Pricing";
import Practice from "@/pages/Practice";
import SessionReport from "@/pages/SessionReport";
import Team from "@/pages/Team";
import Leaderboard from "@/pages/Leaderboard";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import JoinTeam from "@/pages/JoinTeam";
import ReferralLanding from "@/pages/ReferralLanding";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App">
            <LangProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/pricing" element={<Pricing />} />
                            <Route path="/payment-success" element={<PaymentSuccess />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/join/:code" element={<JoinTeam />} />
                            <Route path="/r/:code" element={<ReferralLanding />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/practice"
                                element={
                                    <ProtectedRoute>
                                        <Practice />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/session/:id"
                                element={
                                    <ProtectedRoute>
                                        <SessionReport />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/team"
                                element={
                                    <ProtectedRoute>
                                        <Team />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/settings"
                                element={
                                    <ProtectedRoute>
                                        <Settings />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/leaderboard"
                                element={
                                    <ProtectedRoute>
                                        <Leaderboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <Admin />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </BrowserRouter>
                    <Toaster
                        theme="dark"
                        position="top-right"
                        toastOptions={{
                            style: {
                                background: "#121214",
                                border: "1px solid rgba(255,255,255,0.08)",
                                color: "#f8f8f8",
                                borderRadius: "2px",
                                fontFamily: "Outfit, sans-serif",
                            },
                        }}
                    />
                </AuthProvider>
            </LangProvider>
        </div>
    );
}

export default App;
